<template>
    <div>
      <div v-show="isshowPannel " class="wyplayer " :class="{'i-as-show':isShowPlayer,'safe_wyplayer':showTab,'tab_safe_wyplayer':!showTab}" >
          <audio
              id="wyplayer" 
              preload="auto" 
              :src="current_sections_info.mates_path"
              @timeupdate="ontimeupdate"
              @loadeddata="onloadeddata" 
              @playing="onplaying" 
              @canplay="oncanplay"
              @play="onplay"
              @pause="onpause"
              @ended="onended"
          >
              你的浏览器不支持audio标签
          </audio>
          <div class="cover_wrap">
            <div class="cover_content">
              <img class="cover" :src="cover" alt="">
              <div class="wyplayer_play">
                <span v-if="audio_type=='pause' || audio_type=='load'" @click="bindPlay" class="iconfont iconbofangbeifen13"></span>
                <span v-if="audio_type=='play' " @click="bindPause" class="iconfont iconzantingtingzhi1 "></span>
                    
              </div>
            </div>
          </div>
          <div class="cover_desc">
            <div class="wyplayer_name_zone" @click="gotoFmIndex" >
              <div class="wyplayer_name">{{current_sections_info.name}}</div>
              <div class="wyplayer_time">{{progress_current_duration}}/{{current_sections_info.mates_duration_his}}</div>
            </div>
            <div class="wyplayer_op">
              <div class="wyplayer_list"><span @click="bindOpenPlayList" class="iconfont iconbofangliebiao1 font-operation"></span></div>
              <div class="wyplayer_del"><span  @click="bandClosePlayerPannel" class="iconfont iconguanbi3 font-operation"></span></div>
            </div>
          </div>
      </div>

      <!-- 播放列表 -->
      <van-popup v-model="is_show_play_list" round  position="bottom" :style="{ height: '80%' }" >
        <div class="play_list_wrap">
            <div class="play_header">
              <div>
                <div v-if="switch_play_type==1" @click="switch_play"><span class="iconfont iconfontplay iconshunxubofang "></span><span class="play_op_text">顺序播放</span></div>
                <div v-if="switch_play_type==2" @click="switch_play"><span class="iconfont iconfontplay icondanquxunhuan "></span><span class="play_op_text">单曲循环</span></div>
                <div v-if="switch_play_type==3" @click="switch_play"><span class="iconfont iconfontplay iconliebiaoxunhuan "></span><span class="play_op_text">列表循环</span></div>
              </div>
              <div>
                <div @click="bindClosePlay"><span class="iconfont iconguanbi1 iconqingkong "></span><span class="play_op_text">关闭窗口</span></div>
              </div>
            </div>
            <div class="play_content_list">
              <template v-for="(item, index)  in play_list" >
                <van-cell 
                  class="speed_item" 
                  v-show="current_group.sections_group_id=='' || item.sections_group_id==current_group.sections_group_id "
                  :key="index" 
                    @click="bindPlayToggle(item,index)"
                >
                  <div class="play_icon">
                    <template v-if="current_sections_id==item.sections_id ">  
                      <div v-if="audio_type=='play' || audio_type=='load' " class="wave_container">
                          <div class="one wave"></div>
                          <div class="two wave"></div>
                          <div class="three wave"></div>
                      </div>
                      <span v-else class="iconfont iconbofangbeifen13 " ></span>
                    </template>
                    <template v-else>
                      <span class="iconfont iconbofangbeifen13 " ></span>
                    </template>
                  </div>
                  <div class="play_list_zone ">
                    <div class="play_list_name " :class="{play_active:(current_sections_id==item.sections_id?true:false)}" >{{item.name}}</div>
                    <div class="play_list_duration_zone " :class="{play_active:(current_sections_id==item.sections_id?true:false)}" >
                      <div class="play_list_duration">{{item.mates_duration_cn}}</div>
                      <div class="play_list_rate">{{item.time_percentage}}%</div>
                    </div>
                  </div>
                  <div class="play_del"><span @click.stop="bindDelPlay(item,index)" class="iconfont iconguanbi2"></span></div>
                </van-cell>
              </template>
            </div>
            <div v-if="0" class="speed_close" @click="bindClosePlay">关闭</div>
        </div>
      </van-popup>
    </div>
</template>

<script>
  var fmInterval

  import { ImagePreview,Icon ,Checkbox,Empty,Cell,CellGroup ,Image as VanImage,Popup } from 'vant';
  import env from '../../utils/env'

  export default {
      name: "wyplayer",
      components:{
          [Icon.name]:Icon,
          [Popup.name]:Popup,
          [Cell .name]:Cell,
          [CellGroup .name]:CellGroup,
      },
      props:{
      },

      data(){
          return {
            isshowPannel:false,
            player_list:[],
            isShowPlayer:false,
            scrollTop:0,
            is_show_play_list:false,
            switch_play_type:1,// 1|顺序播放、2|列表循环、3|单曲循环
            play_list: [],    //播放列表
            audio_type: 'pause', // 暂停、播放、准备 pause  play load
            current_multiplier_speed: 1,
            duration_time: 0,
            current_group: {"name":"全部",    sections_group_id:"",  active:true},

            up_audio_type: 'pause', // 上一次之前状态

            course_id:'',
            current_sections_id:'',
            cover:'',

            current_sections_info:{},
            currentTab:0, 

            progress_current_duration:"00:00",
            progress_all_duration:"00:00",
            progress_current_unix:0,
            progress_all_unix:0,

            showTab:false,
            reset_time: true, // 重置播放时长
            auto_play: true, // 是否自动播放，第一个不需要自动播放
          }
      },
      watch:{
        '$route' (to, from) {
          this.showTab = to.meta.showTab

          let audioPlayer = document.getElementById('wyplayer');
          if(audioPlayer && this.current_sections_info!=''){
            // 进入禁止播放
            if(to.meta.show_wyplayer==false){
              if(to.name=='fm/index'){
                this.up_audio_type = this.audio_type
                this.isshowPannel = false
              }else{
                
                this.up_audio_type = this.audio_type
                audioPlayer.pause()
                this.isshowPannel = false
              }
              
            }
            //console.error(this.up_audio_type)
            // 从 禁止播放页面 进入允许播放页面
            if(to.meta.show_wyplayer==true && from.meta.show_wyplayer==false){
              
              //this.isshowPannel = true
              if(this.course_id!=''){
                this.isshowPannel = true
              }
              this.$EventBus.$emit(
                "player_pannel_status", 
               {'isshowPannel': true});

              if(this.up_audio_type == 'play'){
                audioPlayer.play()
              }
            }
          }
          
        }
      },
      created() {  
        
        this.$EventBus.$on('start_play', target => {
            console.log("start_playstart_playstart_playstart_playstart_play,",target)
            this.course_id = target.course_id
            
            this.cover = target.cover
            if(target.show_wyplayer==true){
              this.isshowPannel = true
              this.isShowPlayer = true

              this.$EventBus.$emit(
                "player_pannel_status", 
               {'isshowPannel': true});
            }
            this.gatherFmDuration()

            if(this.current_sections_id!='' && this.current_sections_id==target.sections_id){
              // 如果当前章节与之前章节一致不进行请求
              console.log("当前章节与之前章节一致不进行请求")
              this.reset_time = false

              this.setCurrTabIndex(this.current_sections_id)

              this.getAudioDetail()
            }else{
              if(target && target.status && target.status=='pause'){
                this.auto_play = false
                console.log("只获取列表不播放")
                
                this.current_sections_id = target.sections_id
                this.setCurrTabIndex(this.current_sections_id)

                
                this.getPlayList()
              }else{
                console.log("获取列表，并播放")
                this.current_sections_id = target.sections_id
                this.setCurrTabIndex(this.current_sections_id)

                if(this.play_list.length>0 && this.play_list.length==target.list_length){
                  // 减少请求
                  this.getAudioDetail()
                }else{
                  this.getPlayList()
                }
                
              }
              
            }
            
        });

        this.$EventBus.$on('setCurrAudio', target => {
          this.gatherFmDuration()
          this.current_sections_id = target.sections_id
          this.setCurrTabIndex(this.current_sections_id)
          this.getAudioDetail()
        });

        this.$EventBus.$on('play', target => {
          console.log('play','this.current_sections_id',this.current_sections_id)
          //this.setCurrTabIndex(this.current_sections_id)
          this.gatherFmDuration()
          this.bindPlay()
        });

        this.$EventBus.$on('pause', target => {
          // 从 FM index 过来时,如果暂停，则需要把this.up_audio_type 设置为暂停
          this.up_audio_type = 'pause'
          this.gatherFmDuration()
          this.bindPause()
        });

        //打开播放列表
        this.$EventBus.$on('openPlayList', target => {
            this.bindOpenPlayList()
        });
        //打开播放速度
        this.$EventBus.$on('set_multiplier_speed', target => {
            this.current_multiplier_speed = target.current_multiplier_speed
            this.setplaybackRate()
        });

        //设置播放进度
        this.$EventBus.$on('set_current_time', target => {
            this.progress_current_unix = target.currentTime
            this.setCurrentTime()
        });

        //外部接口
        this.$EventBus.$on('getStatus', target => {
            //广播状态
            this.$EventBus.$emit("player_status",{'audio_type':this.audio_type});
        });

        //设置当前组
        this.$EventBus.$on('setCurrGroup', target => {
            
            this.current_group = target.current_group
            console.log(this.current_group)
        });
        
      },
      mounted() {
        window.addEventListener('scroll', this.scrollToTop)
      },
      methods:{
        init(item){

        },
        test(){
          console.log(this.audio_type)
        },
        gotoFmIndex(){
          this.$router.push(this.util.urlPrefix+'/fm/index?course_id='+this.course_id+'&sections_id='+this.current_sections_id+'&token='+this.util.token)
        },
        ontimeupdate(e){
          let audioPlayer = document.getElementById('wyplayer');
          if(audioPlayer){
            this.progress_current_unix = audioPlayer.currentTime
            
            // 显示不进行更新
            this.progress_current_duration = this.util.getTime(this.progress_current_unix);

            //计算播放百分比
            var time_percentage = Math.floor(this.progress_current_unix / this.play_list[this.currentTab].mates_duration * 100);
            this.play_list[this.currentTab].time_percentage=time_percentage;

            //广播
            this.$EventBus.$emit(
              "player_timeupdate", 
              {'currentTime':this.progress_current_unix}
            );
          }
          

          
        },
        onloadeddata(e){
          console.warn('元数据加载::onloadeddata 设置audio_type::load')
          let audioPlayer = document.getElementById('wyplayer');
          this.progress_all_unix = audioPlayer.duration
          this.progress_all_duration = this.util.getTime(this.progress_all_unix);

          // 切换视频后
          this.audio_type = 'load'
        },
        onplaying(e){
          console.warn('播放中::onplaying, 设置audio_type::play')

          this.audio_type='play'

          this.$EventBus.$emit(
            "player_playing", 
            {'audio_type': 'play','course_id':this.course_id,'current_sections_id': this.current_sections_id}
          );
          //this.audio_type='play'
          console.log("启动定时器")
          this.setFmInterval()

          console.log("设置倍速")
          this.setplaybackRate()
        },
        oncanplay(e){
          //视频可以播放了
          console.warn('视频可以播放了::oncanplay，设置audio_type::pause')
          
          const _this = this

          this.$EventBus.$emit(
            "player_canplay", 
            {'course_id':this.course_id,'current_sections_id': this.current_sections_id}
          );
        },
        onplay(e){
          console.warn('点击播放,不一定在onloadeddata之前::onplay')
          console.log('onplay, 不一定正在播放')
        },
        onpause(e){
          console.warn('暂停::onpause 设置audio_type::pause')
          this.audio_type='pause'

          this.gatherFmDuration()

        },
        onended(e){
          console.warn('播放结束')
          if(this.switch_play_type==1){ //顺序播放
            this.bindNextAudio()
          }else if(this.switch_play_type==2){//单曲循环
            let audioPlayer = document.getElementById('wyplayer');
            audioPlayer.currentTime = 0
            audioPlayer.play()
          }else{//列表循环
            this.bindNextAudio()
          }
        },
        bindNextAudio(){
          let index = (this.currentTab+1)
          console.log(index,this.currentTab,this.play_list.length)
          if(index < this.play_list.length){

              console.log('bindNextAudio index',index)
              let item = this.play_list[index]
              this.current_sections_id = item.sections_id

              this.getAudioDetail()
              this.currentTab++
          }else{
            if(this.switch_play_type==3){
              // 如果是列表循序，调到第一个视频
              console.log('列表循序，调到第一个视频')
              let item = this.play_list[0]
              this.current_sections_id = item.sections_id

              this.getAudioDetail()
              this.currentTab = 0

            }else{
              this.util.showToast({
                  message:'列表最后一个了'
              });
            }
            
          }
        },


        setplaybackRate(){
          let audioPlayer = document.getElementById('wyplayer');
          audioPlayer.playbackRate = this.current_multiplier_speed
        },
        setCurrentTime(){
          let audioPlayer = document.getElementById('wyplayer');
          audioPlayer.currentTime = this.progress_current_unix
        },
        bindPlay(){
          console.log('bindPlay!!!!!!!!!!!!!!!!!!');
          let audioPlayer = document.getElementById('wyplayer');
          audioPlayer.play()
        },
        bindPause(){
          console.log('bindPause');
          let audioPlayer = document.getElementById('wyplayer');
          audioPlayer.pause()
        },
        bandClosePlayerPannel(){
          let audioPlayer = document.getElementById('wyplayer');
          audioPlayer.pause()
          this.isshowPannel = false

          this.$EventBus.$emit(
                "player_close", 
               {'course_id':this.course_id,'sections_id':this.current_sections_id});
          
          // 释放所有资源
          setTimeout(() => {
            this.play_list = []
            this.course_id = ''
            this.current_sections_id = ''
            this.current_sections_info = ''
            this.cover = ''
          }, 500);
          

          
        },
        getPlayList(){
          console.log('getPlayList'); 
          this.getCatalog()
        },
        // 播放列表
        switch_play(){
          if(this.switch_play_type==3){
            this.switch_play_type = 0
          }
          this.switch_play_type ++

          this.$EventBus.$emit(
            "switch_play_type", 
            {'switch_play_type':this.switch_play_type}
          );
        },
        setCurrTabIndex(sections_id){
          var index = 0;
          for (var i=0; i < this.play_list.length; i++) {
            if (this.play_list[i].sections_id==sections_id) {
              index = i
              break;
            }
          }
          this.currentTab = index

        },
        bindDelPlay(item,index){
          console.log(this.play_list)
          this.play_list.splice(index, 1)



          // 重新计算当前索引位置,如果删除的是前面的，当前索引值需要减1
          if(index<this.currentTab){
            this.currentTab --
          }
          // 同步
          this.$EventBus.$emit(
                "player_del_list", 
               {'index':index});
        },
        bindClosePlay(){
          this.is_show_play_list = false
        },
        bindOpenPlayList(){
          this.is_show_play_list = true
        },
        bindPlayToggle(item,index){
          //播放列表
          //this.is_show_play_list = false
          //TODO 需要封装
          // 切换前上报时长
          this.gatherFmDuration()

          let myitem = this.play_list[index]
          this.current_sections_id = myitem.sections_id

          //this.switchNavSection(this.current_sections_id)
          
          this.getAudioDetail()
        },
        scrollToTop() {
          var _self =this;
          var top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

          if(top <=0){
              top = 0
          }else if(top > window.innerHeight){
              top = window.innerHeight;
          }

          if (top > this.scrollTop || top == window.innerHeight) {
              // console.log('向下滚动');
              this.isShowPlayer=false;
          } else {
              // console.log('向上滚动');
              this.isShowPlayer=true;
          }

          setTimeout(function () {
              _self.scrollTop=top;
          },0)
        },
        getCatalog(){
              const _self = this
              this.util.server.mini_v2_course.set_catalog({
                    data: {
                        course_id: this.course_id,
                        sections_id: this.current_sections_id,
                        sections_group_id: this.current_group.sections_group_id,
                        sort:1
                    },
                    callback: (res => {
                        const { code, data, msg } = res; 
                        //赋值总数量
                        if(data.total){
                            this.total_sections = data.total;
                        }

                        if(data.items.length>0) {

                            /**
                             * 数据与处理
                             * 1. 计算百分比
                             * 2. 找出当前播放章节(如果携带了,以选择章节为准,否则以最近播放为准)
                             */
                            for (var i = 0; i < data.items.length; i++) {
                                //计算播放百分比
                                var time_percentage = Math.floor(data.items[i].last_play_position / data.items[i].mates_duration * 100);
                                data.items[i].time_percentage = time_percentage;

                                data.items[i].active = false

                                if (data.items[i].curr_section && this.current_sections_id == '') {
                                  this.current_sections_id=data.items[i].sections_id;
                                  data.items[i].active = true
                                }
                                
                            }

                            var scrollLeft = this.scrollXS;//左滑动定位
                            if (this.current_sections_id == '') {
                                scrollLeft = 160 * data.items.length;//元素宽度
                            }

                            this.play_list    = data.items // 播放列表

                            // 如果本地章节为空,以最新章节为准
                            if(_self.current_sections_id == '' && data.items.length>0){
                                this.current_sections_id = data.items[0].sections_id;

                            }else{

                            }
                             this.$EventBus.$emit(
                                "player_list", 
                              {'play_list':this.play_list});

                            this.setCurrTabIndex(this.current_sections_id)
                            this.getAudioDetail()
                            //console.log(' this.current_sections_id', this.current_sections_id)
                            
                        }else{
                           
                            
                        }

                    }),
                    is_show_load: false,
                });
        },
        getAudioDetail(){
          
          //TODO  广播一下当前会需要播放的课程信息
          this.$EventBus.$emit(
          "player_switch_play", 
          {'course_id':this.course_id,'sections_id':this.current_sections_id});

          this.$EventBus.$emit(
          "player_switch_play2", 
          {'course_id':this.course_id,'sections_id':this.current_sections_id});

          const _self=this;
          this.util.server.mini_course.sections_detail({
              data: {
                  sections_id: this.current_sections_id
              },
              callback: (res => {
                  const { code, data, msg } = res; 

                  _self.current_sections_info = data;
                  _self.current_sections_info.mates_duration_his = this.util.getTime(data.mates_duration);
                  
                  _self.$EventBus.$emit(
                    "player_switch_play_after", _self.current_sections_info);
                  // 1. 设置进度条
                  //this.progress_slider = data.last_play_position
                  if(_self.reset_time){
                      _self.$nextTick(function () {
                      let audioPlayer = document.getElementById('wyplayer');
                      // 2. 设置播放位置
                      console.log('env.iOS',env.iOS)
                      console.log('env.wxpc',env.wechatdevtools)

                      var last_play_position = data.last_play_position
                      // 如果已经播放完了 则重置播放位置为零，否则继续之前位置
                      if(data.last_play_position == data.mates_duration){
                        last_play_position = 0
                      }
                      if(env.iOS && !env.wechatdevtools){
                        audioPlayer.addEventListener("canplay",function() {
                          audioPlayer.currentTime = last_play_position
                        });
                      }else{
                        audioPlayer.currentTime = last_play_position
                      }
                      // 3. 自动播放
                      if(_self.auto_play){
                        console.log("audioPlayer",audioPlayer)
                        audioPlayer.play()
                      }else{
                        _self.auto_play = true
                      }
                      
                    })
                  }else{
                    _self.reset_time = true
                  }
                  
              }),
              is_show_load: false
            })
        },
          
        bindBoFangShiChang(){
            if(!this.play_list){
                return
            }
            if(this.duration_time==0){//如果播放时长为零，不进行上报
              // 比如处于暂停状态，然后进行切换视频
              console.warn("播放时长为零,不进行上报")
              return
            }
            
            //播放时长
            var _self=this;
            this.util.server.event.event({
                data: {
                    message:{
                        course_id:this.course_id,
                        duration:this.duration_time,
                        // play_position:this.audioCurrentTime,
                        play_position: parseInt(this.progress_current_unix),
                        train_id:this.util.train_id,
                        p_course_id: _self.p_id,
                        uid:this.util.getUserId.get(),
                        sections_id:this.current_sections_id,
                        index:this.current_sections_id,
                    },
                    code:10012,
                },
                callback: (res => {})
            });
        },
        //设置定时检测
        setFmInterval(){
          const _this = this
          // 启动前，先重置, 清除事件没有触发
          this.duration_time = 0
          clearInterval(fmInterval)

          fmInterval=setInterval(function () {
              // console.log("时间增加",_this.duration_time)
              _this.duration_time +=1;
              if(_this.duration_time>120){ // 如果超过60秒上报一次，解决直接刷新数据问题
                console.log("时间太长,上报一次数据")
                _this.bindBoFangShiChang()
                _this.duration_time = 0
              }

          },1000);
        },
        gatherFmDuration(){
          this.bindBoFangShiChang()
          this.duration_time = 0
          clearInterval(fmInterval)
        }

      },
  }
</script>

<style scoped>
    @supports (bottom: env(safe-area-inset-bottom)) {
      .safe_wyplayer { 
        /* bottom:  50px + env(safe-area-inset-bottom); */
        bottom: calc(50px + env(safe-area-inset-bottom)) !important
      }
      .tab_safe_wyplayer { 
        /* bottom:  50px + env(safe-area-inset-bottom); */
        bottom: 0px !important
      }
    }
    .tab_safe_wyplayer { 
        /* bottom:  50px + env(safe-area-inset-bottom); */
        bottom: 0px !important
      }
    .wyplayer{
      position: fixed;
      background: rgba(0,0,0,0.75);
      height: 50px;
      width: 100%;
      z-index: 2;
      box-shadow: 0px 0px 5px 2px #ccc;
      max-width: 480px;
      margin: 0 auto;
      right: 0;
      left: 0;
      bottom: 50px;
      /* border-radius: 5px; */
      transform:translate3d(0,130%,0);
      -webkit-transition: -webkit-transform 0.3s;
      transition: -webkit-transform 0.3s;
      transition: transform 0.3s;
      transition: transform 0.3s, -webkit-transform 0.3s;
    }
    .cover{
      width: 50px;
      height: 50px;
      border-radius: 25px;
      object-fit: cover;
     
    }
    .i-as-show{
        transform:translate3d(0,0,0);
    }
    .cover_desc{
      display: flex;
      margin-left: 64px;
      padding: 0px 13px;
      justify-content: space-between;
      height: 50px;
      align-items: center;
      
    }
    .wyplayer_op{
      width: 65px;
      display: flex;
      justify-content: space-around;
    }
    .wyplayer_name{
      font-size: 14px;
      color: #fff;
      font-weight: 600;
      overflow: hidden;
      white-space: nowrap;
      width: 207px;
      text-overflow: ellipsis;
    }
    .wyplayer_time{
      margin-top: 4px;
      font-size: 11px;
      color: #fff;
    }
    .font-operation{
      font-size: 14px;
      color: #fff;
    }
    .cover_content{
      position: absolute;
      top: -8px;
      left: 20px;
      /* background: radial-gradient(black, #19040400); */
    }
    .cover_wrap{
      position: relative;
    }
    .wyplayer_play{
      /* width: 25px;
      height: 25px; */
      /* line-height: 25px;
      border-radius: 50%; */
      position: absolute;
      top: 12px;
      left: 12px;
      /* background: #FFF; */
      text-align: center;
    }
    .wyplayer_play .iconbofangbeifen13 {
      font-size: 26px;
    }
    .wyplayer_play .iconzantingtingzhi1 {
      font-size: 26px;
    }



    
    /* 播放列表 */
    .play_header{
      height: 67px;
      display: flex;
      justify-content: space-between;
      line-height: 67px;
      padding: 0px 18px;
    }
    .play_content_list{
      height: 67vh;
      overflow-y: scroll;
    }
    .play_op_text{
      padding-left: 6px;
      font-size: 14px;
      color: #2A2A2C;
      vertical-align:top;
    }
    .iconfontplay{
      font-size: 17px;
      color: #000;
      display: inline-block;
      width: 20px;
    }
    .play_list_zone{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .play_header{
      border-bottom: 1px solid #DCDCDC;;
    }
    .play_icon{
      width: 30px;
      text-align: left;
      line-height: 40px;
    }
    .play_del{
      width: 30px;
      text-align: right;
      line-height: 40px;
    }
    .play_list_name{
      font-size: 14px;
      color: #333237;
      font-weight: 600;
      line-height: 18px;
    }
    .play_list_duration_zone{
      display: flex;
      color: #585858;
    }
    .play_list_duration{
      width: 60px;
      font-size: 11px;
      line-height: 18px;
    }
    .play_list_rate{
      font-size: 11px;
      line-height: 18px;
    }
    .play_icon .iconbofangbeifen13{
      color: #434247;
      font-size: 20px;
    }
    .play_del .iconguanbi2{
      color: #000;
      font-size: 25px;
    }
    .play_active{
      color: #ff8547 !important;
    }


    .speed_close{
      position: absolute;
      text-align: center;
      bottom: 15px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      width: 100%;
      letter-spacing: 10px;
    }

    
    .speed_item >>> .van-cell__value{
      display: flex;
      justify-content: space-between;
    }
    .speed_item:active{
      background-color: #eceaea;
    }
    .speed_item_name_active{
      color: #FF6702 !important
    }
    .speed_item_name{
      font-size: 14px;
      font-weight: 500;
      line-height: 40px;
      color: #616161;
    }
    .speed_item_check{
      display: flex;
      align-items: center;
    }



    /* 小组件 */
 .wave{
    width:3px;
    height: 100%;
    margin-left: 3px;
    background-color: #ff8547;
    vertical-align: middle;
    display: inline-block;
  }

.wave_container{
    width: auto;
    height: 20px;	
  }
  .wave_container .one{
    animation:yuying1 0.6s infinite 0.1s;
      -webkit-animation:yuying1 0.6s infinite 0.1s;
  }
  .wave_container .two{
    animation:yuying1 0.6s infinite 0.3s;
      -webkit-animation:yuying1 0.6s infinite 0.3s;
  }
  .wave_container .three{
    animation:yuying1 0.6s infinite 0.5s;
      -webkit-animation:yuying1 0.6s infinite 0.5s;
  }
@keyframes yuying1{
    0%{
      height: 10%;
    }
    20%{
      height: 50%;
    }
    50%{
      height: 100%;
    }
    80%{
      height: 50%;
    }
    100%{
      height: 0%;
    }
  }
</style>
